<div class="container">
  <div class="header-wrapper">
    <div class="left-section">
      @if (!new) {
        <h1>
          {{ 'case.edit-case-title' | translate | capitalize }}
        </h1>
      }
      @if (new) {
        <h1>{{ 'case.new-case-title' | translate | capitalize }}</h1>
      }
      <p matRipple class="back-text" (click)="back()">
        <mat-icon>arrow_back</mat-icon>
        <ng-container>{{ 'general.words.back' | translate | capitalize }}</ng-container>
      </p>
    </div>
    @if (isSuperAdmin && case) {
      <div class="lock-wrapper">
        <button
          mat-icon-button
          [matTooltip]="(case.lockedByAdmin ? 'case.lock.disable' : 'case.lock.enable') | translate | capitalize"
          (click)="case.lockedByAdmin = !case.lockedByAdmin; saveLockState()">
          <mat-icon>{{ case.lockedByAdmin ? 'lock' : 'lock_open' }}</mat-icon>
        </button>
      </div>
    }
  </div>
  @if (case || new) {
    <mat-card class="card-primary" appearance="outlined">
      <div class="row" [style]="{ margin: 0 }">
        <div class="col s12 m12 l6">
          <p style="font-weight: 500; font-size: 16px">
            {{ 'case.inputs.title' | translate | capitalize }}
          </p>
          <mat-form-field class="full-width" appearance="outline">
            <input [formControl]="caseTitleFormControl" (change)="onTitleChange()" matInput />
            @if (this.caseTitleFormControl.hasError('required')) {
              <mat-error>{{ 'general.inputs.errors.required' | translate | capitalize }} </mat-error>
            }
          </mat-form-field>
          <p style="font-weight: 500; font-size: 16px">
            {{ 'case.inputs.embed-source' | translate | capitalize }}
          </p>
          <mat-radio-group
            [formControl]="embedSourceFormControl"
            (change)="onEmbedSourceChange()"
            class="embed-source-radio-group">
            <mat-radio-button color="primary" value="custom">
              {{ 'case.inputs.embed-source-custom' | translate | capitalize }}
            </mat-radio-button>
            <mat-radio-button color="primary" value="uploaded">
              {{ 'case.inputs.embed-source-uploaded' | translate | capitalize }}
            </mat-radio-button>
          </mat-radio-group>
          @if (embedSourceFormControl.value === 'uploaded') {
            <p style="font-weight: 500; font-size: 16px">
              {{ 'case.inputs.static-site' | translate | capitalize }}
            </p>
            <mat-form-field class="full-width" appearance="outline">
              <input
                matInput
                readonly
                style="cursor: pointer"
                [value]="case.staticSite?.name || ''"
                [placeholder]="'case.inputs.static-site-placeholder' | translate | capitalize"
                (click)="openStaticSitePickerDialog()" />
              <mat-icon matSuffix style="cursor: pointer" color="primary" (click)="openStaticSitePickerDialog()"
                >search</mat-icon
              >
              @if (case.staticSite) {
                <mat-icon
                  matSuffix
                  style="cursor: pointer"
                  color="primary"
                  (click)="$event.preventDefault(); openStaticSitePreview()"
                  >open_in_new</mat-icon
                >
              }
            </mat-form-field>
          }
          @if (embedSourceFormControl.value === 'custom') {
            <p style="font-weight: 500; font-size: 16px">
              {{ 'case.inputs.embed-url' | translate | capitalize }}
            </p>
            <mat-form-field class="full-width" appearance="outline">
              <input [formControl]="iframeUrlFormControl" (change)="onIframeUrlChange()" matInput />
              <mat-icon
                matSuffix
                style="cursor: pointer"
                color="primary"
                (click)="$event.preventDefault(); openIframeInNewTab()"
                >open_in_new</mat-icon
              >
            </mat-form-field>
          }
          <mat-checkbox color="primary" [(ngModel)]="case.isQuiz" (change)="changes = true; onIsQuizChange()">
            {{ 'case.inputs.embed-url-is-quiz-checkbox-label' | translate | capitalize }}
          </mat-checkbox>
          <mat-icon
            color="primary"
            style="cursor: pointer"
            [matTooltip]="'case.inputs.embed-url-quiz-tooltip' | translate | capitalize"
            (click)="openQuizInformationDialog()"
            >info_outlined</mat-icon
          >
          <p style="font-weight: 500; font-size: 16px; margin-top: 15px">
            {{ 'case.inputs.ai-chat-url' | translate | capitalize }}
          </p>
          <mat-form-field class="full-width" appearance="outline" (change)="onAiChatUrlChange()">
            <input [formControl]="aiChatUrlFormControl" matInput />
          </mat-form-field>
          <p style="font-weight: 500; font-size: 16px; margin-top: 15px">
            {{ 'general.words.patient' | translate | capitalize }}
          </p>
          <div class="patient-card">
            @if (case.patient.department) {
              <div class="patient-img-wrapper">
                @if (patientImageUrl === 'icon') {
                  <mat-icon class="profile-img">account_box</mat-icon>
                }
                @if (patientImageUrl !== 'icon') {
                  <img
                    class="profile-img"
                    defaultImage="/assets/images/loader1.gif"
                    [lazyLoad]="patientImageUrl | authImage | async" />
                }
              </div>
              <div class="patient-info-wrapper">
                <p class="patient-title">
                  {{ getPatientProperty('zoeknaam') }}
                  <mat-icon
                    color="primary"
                    style="cursor: pointer"
                    (click)="changPatient()"
                    [matTooltip]="'case.change-patient' | translate | capitalize">
                    edit
                  </mat-icon>
                </p>
                <p class="patient-birthdate">
                  {{ getPatientProperty('geboortedatum') | date: 'dd-MM-yyyy' }}
                </p>
                <p class="patient-department">
                  {{ case.patient.department?.careInstitution?.name }},
                  {{ case.patient.department?.name }}
                </p>
              </div>
            }
            @if (!case.patient || !case.patient.department) {
              <button style="margin-bottom: 25px" mat-stroked-button color="primary" (click)="changPatient()">
                {{ 'case.choose-patient' | translate | capitalize }}
              </button>
            }
          </div>
          <p style="font-weight: 500; font-size: 16px">
            {{ 'epd.organisation.department.role' | translate | capitalize }}
          </p>
          <mat-form-field class="full-width" appearance="outline">
            <mat-select [formControl]="roleFormControl" (selectionChange)="onRoleChange()" required>
              @for (role of case.patient.department?.roles; track role) {
                <mat-option [value]="role.id">{{ role.name }} </mat-option>
              }
            </mat-select>
            @if (roleFormControl.hasError('required')) {
              <mat-error>{{ 'general.inputs.errors.required' | translate | capitalize }} </mat-error>
            }
          </mat-form-field>
        </div>
        <div class="col s12 m12 l6">
          <p style="font-weight: 500; font-size: 16px">
            {{ 'case.tasks.title' | translate | capitalize }}
          </p>
          @if (tasksLoading) {
            <ngx-skeleton-loader
              animation="progress"
              [theme]="{
                width: '100%',
                marginTop: '0px',
                marginBottom: '0px',
                height: '45px',
              }"
              count="4"
              appearance="line"></ngx-skeleton-loader>
            <div style="height: 35px"></div>
          }
          @if (!tasksLoading) {
            <div>
              <div cdkDropList (cdkDropListDropped)="drop($event)">
                @for (task of case.tasks; track task) {
                  @if (!task.edit) {
                    <div cdkDrag class="draggable-task">
                      <mat-icon class="drag-icon" cdkDragHandle>drag_indicator</mat-icon>
                      <div class="first-mat-line">{{ task.title }}</div>
                      <mat-icon class="task-edit-btn" color="primary" (click)="editTask(task)">edit</mat-icon>
                    </div>
                  }
                  @if (task.edit) {
                    <div cdkDrag [cdkDragDisabled]="task.edit" class="task-list-item edit-item">
                      <mat-form-field class="full-width edit-task-form-field" appearance="outline">
                        <mat-label>{{ 'general.words.title' | translate | capitalize }}</mat-label>
                        <input matInput type="text" [(ngModel)]="task.title" />
                      </mat-form-field>
                      <mat-form-field class="full-width edit-task-form-field" appearance="outline">
                        <mat-label>{{ 'general.words.description' | translate | capitalize }}</mat-label>
                        <textarea matInput [(ngModel)]="task.description" cdkTextareaAutosize></textarea>
                      </mat-form-field>
                      <div class="task-checkbox-wrapper">
                        <mat-checkbox
                          class="task-checkbox"
                          [(ngModel)]="task.toSubmit"
                          [disabled]="task.isQuiz"
                          color="primary"
                          >{{ 'case.inputs.to-submit' | translate | capitalize }}</mat-checkbox
                        >
                        @if (task.toSubmit) {
                          <mat-form-field
                            class="full-width to-submit-function"
                            style="width: 300px"
                            appearance="outline">
                            <mat-label>{{ 'case.inputs.to-submit-select-label' | translate | capitalize }}</mat-label>
                            <mat-select
                              [disabled]="
                                !case.patient ||
                                !case.patient.department ||
                                !case.patient.department.careInstitution ||
                                !case.patient.department.careInstitution.id
                              "
                              [(ngModel)]="task.functionToSubmit">
                              @for (category of availableFunctions; track category) {
                                <mat-optgroup>
                                  {{ category.name }}
                                  @for (function of category.categoryAppFunctions; track function) {
                                    <mat-option [value]="function.appFunction">
                                      {{ function.appFunction.title }}
                                    </mat-option>
                                  }
                                </mat-optgroup>
                              }
                            </mat-select>
                            @if (
                              !case.patient ||
                              !case.patient.department ||
                              !case.patient.department.careInstitution ||
                              !case.patient.department.careInstitution.id
                            ) {
                              <mat-hint style="color: red">{{
                                'case.inputs.to-submitted-patient-hint' | translate | capitalize
                              }}</mat-hint>
                            }
                          </mat-form-field>
                        }
                        <mat-checkbox
                          class="task-checkbox"
                          [(ngModel)]="task.toRate"
                          [disabled]="task.isQuiz"
                          color="primary">
                          {{ 'case.inputs.to-grade-checkbox' | translate | capitalize }}</mat-checkbox
                        >
                      </div>
                      <div style="display: flex; justify-content: end; align-items: flex-end">
                        <button style="float: right; margin: 2px" mat-stroked-button (click)="cancelEditTask(task)">
                          {{ 'general.words.cancel' | translate | capitalize }}
                        </button>
                        <button
                          style="float: right; margin: 2px"
                          mat-flat-button
                          color="warn"
                          [disabled]="task.isQuiz"
                          (click)="deleteTask(task)">
                          <mat-icon style="color: white">delete</mat-icon>
                        </button>
                        <button
                          style="float: right; margin: 2px"
                          mat-flat-button
                          color="primary"
                          (click)="saveEditTask(task)">
                          <mat-icon style="color: white">save</mat-icon>
                        </button>
                      </div>
                    </div>
                  }
                }
                @if (case.tasks && case.tasks.length < 1) {
                  <div>
                    <p>
                      <i>{{ 'case.no-tasks-found' | translate | capitalize }}</i>
                    </p>
                  </div>
                }
                <div class="add-task-button">
                  <button
                    mat-icon-button
                    [matTooltip]="'case.add-task' | translate | capitalize"
                    (click)="addTask()"
                    color="primary">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>
            </div>
          }
          <p style="font-weight: 500; font-size: 16px">
            {{ 'case.ratingsystem' | translate | capitalize }}
          </p>
          <mat-form-field class="full-width" appearance="outline">
            <mat-select
              [formControl]="ratingFormControl"
              required
              (selectionChange)="onRatingSystemSelectChange($event)">
              @for (ratingSystem of ratingSystems; track ratingSystem) {
                <mat-option [value]="ratingSystem.id">
                  <span>{{ ratingSystem.name }}</span>
                </mat-option>
              }
            </mat-select>
            @if (ratingFormControl.hasError('required')) {
              <mat-error>{{ 'general.inputs.errors.required' | translate | capitalize }} </mat-error>
            }
          </mat-form-field>
          <p style="font-weight: 500; font-size: 16px">
            {{ 'case.workgroups-and-students-title' | translate | capitalize }}
          </p>
          <button
            mat-button
            color="primary"
            [disabled]="
              !caseTitleFormControl.valid || tasksLoading || !roleFormControl.valid || !ratingFormControl.valid
            "
            (click)="openEditWorkgroups()">
            <mat-icon>group</mat-icon>
            {{ 'case.link-users-button' | translate | capitalize }} >
          </button>
        </div>
      </div>
      <mat-card-actions align="end">
        <app-spinner-button
          [config]="btnConfig"
          (onClick)="save()"
          [disabled]="
            !changes ||
            !caseTitleFormControl.valid ||
            tasksLoading ||
            !roleFormControl.valid ||
            !ratingFormControl.valid
          "></app-spinner-button>
      </mat-card-actions>
    </mat-card>
  }
</div>
